export const listonespaceswitchActions = {
    switchSpace,
}

function switchSpace(space) {
    return dispatch => {
        dispatch({ type: space });
    }
}